var $ = jQuery = require('jquery');

var phpjs = require('../phpjs');

var Basket = function (obj, options) {
    this.options = options;

    this.data = {};

    this.dataResponse = {};

    this.selector = {};

    this.url = {};

    this.hbs = {};

    this.cookie = {
        someVar: 'someVar'
    };

    this.someVar = [];

    this.init();
};

Basket.prototype.init = function () {
    var
        self = this
        ;

    if (!$('body').hasClass('someclass')) {
        //return;
    }

    self.bindUI();
};

Basket.prototype.bindUI = function () {
    var
        self = this
    //, $link = $(a)
        , someVar = 'bar'
        ;

    //$link.on('click', $.proxy(self.onClickQuickOrder, null, self, $link, someVar))
    this.controlButtonDelFromCart();
};

Basket.prototype._updateModuleCartHead = function () {
    var self = this;
    jQuery.ajax('index.php?route=module/cart_head/callback', {
        type: 'post',
        dataType: 'html',
        success: function (html) {
            $('#wproto-ajax-header-cart').html(html);
            self.controlButtonDelFromCart();
            self._updateBasketQuantity();
        }
    });
};

Basket.prototype.controlButtonDelFromCart = function () {
    var self = this;
    $('#wproto-ajax-header-cart .cart-remove').each(function (i, el) {
        el = $(el);
        el.detach('click');
        el.on('click', $.proxy(self._onDelProductFromCart, null, self));
    });
};

Basket.prototype._updateBasketQuantity = function () {
    var subTotal = 0,
        subQuantity = 0,
        total = 0,
        quantity = 0,
        nodeCartHead = $('#wproto-ajax-header-cart')
        ;
    nodeCartHead.find('.count').each(function (i, nodeCount) {
        nodeCount = $(nodeCount);
        subQuantity = parseInt(nodeCount.find('.product-quantity').html());
        quantity += subQuantity;
        subTotal = subQuantity * parseInt(nodeCount.find('.amount').html().replace(/ /, ''));
        total += subTotal;
    });

    if (quantity) {
        $('.my-cart').removeClass('cart-is-empty');
        $('.total-quantity').html(quantity);
        $('.order-subtotal').html(this.getPriceFormatted(total));
    } else
        $('.my-cart').addClass('cart-is-empty');

};

Basket.prototype._onDelProductFromCart = function (self, ev) {
    var node = $(ev.target),
        product_id = node.attr('data-product_id');
    jQuery.ajax('index.php?route=module/cart/callback', {
        type: 'post',
        dataType: 'html',
        data: 'remove=' + product_id,
        success: function (html) {
            var nodeCartWidget = $('.widget.widget_cart');
            if (nodeCartWidget.length) {
                nodeCartWidget.html(html);
            }
            self._updateModuleCartHead();
        }
    });
};

Basket.prototype.getPriceFormatted = function getPriceFormatted(price, price_max, la_fa) {
    return phpjs.number_format(phpjs.round(price, 0), 0, '.', ' ') + (typeof(price_max) != 'undefined' && price_max > 0 ? ' - ' + phpjs.number_format(phpjs.round(price_max, 0), 0, '.', ' ') : '') + ((la_fa) ? ' <i class="fa fa-rub"></i>' : ' руб.');
};

Basket.prototype._restoreCookie = function () {
    this.someVar = $.cookie(this._getCookieVarName(this.cookie.someVar));
    if (typeof(this.someVar) != 'undefined'
        && /^{/.test(this.someVar)) {
        this.someVar = $.parseJSON(this.someVar);
    } else {
        this.someVar = {};
    }
};

Basket.prototype._updateCookie = function () {
    $.cookie(this._getCookieVarName(this.cookie.someVar), $.toJSON(this.someVar), {path: '/'});
};

Basket.prototype._getCookieVarName = function (localVarName) {
    return 'Basket' + '.' + localVarName
};

Basket.DEFAULTS = {
    selector: 'body'
};

var old = $.fn.Basket;

$.fn.Basket = function (option) {
    return this.each(function () {
        var $this = $(this);
        var data = $this.data('oc.Basket');
        var options = $.extend({}, Basket.DEFAULTS, $this.data(), typeof option == 'object' && option);
        if (!data) $this.data('oc.Basket', (data = new Basket(this, options)));
        if (typeof option == 'string') data[option].call($this)
    })
};

$.fn.Basket.Constructor = Basket;

$.fn.Basket.noConflict = function () {
    $.fn.Basket = old;
    return this
};

var Basket = new Basket();

Basket.init()

module.exports = Basket;



// WEBPACK FOOTER //
// ./assets/javascript/checkout/basket.js